import { render, staticRenderFns } from "./admin-link-trees.vue?vue&type=template&id=54fe0db2&scoped=true&"
import script from "./admin-link-trees.vue?vue&type=script&lang=js&"
export * from "./admin-link-trees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe0db2",
  null
  
)

export default component.exports